import React, { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PDFViewer from '../utility/PDFViewer';
import { useAuth } from '../../AuthContext';

const ViewSolution = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {user}=useAuth()

  // Read fileUrl from query parameters
  const queryParams = new URLSearchParams(location.search);
  const fileUrl = queryParams.get('fileUrl');

  const canvasRef = useRef(null);



  // Handle case when fileUrl is not found
  useEffect(() => {
    if (!fileUrl) {
      // If no fileUrl, redirect back to solutions or show error message
      navigate('/solutions');
    }
  }, [fileUrl, navigate]);



  if (!fileUrl) {
    return <div>No PDF available to view</div>;
  }

  return (
    <div className='container mb-5 mt-3'>
        <Link to={`/student/${user?.email}`} >Back to profile</Link>
        <PDFViewer fileUrl={fileUrl}/>
    </div>
  );
};

export default ViewSolution;
